import { render, staticRenderFns } from "./GoogleAuthenticationUser.vue?vue&type=template&id=73aafaca"
import script from "./GoogleAuthenticationUser.vue?vue&type=script&lang=js"
export * from "./GoogleAuthenticationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports